import { render, staticRenderFns } from "./ConferenceCard.vue?vue&type=template&id=1f77c83e"
import script from "./ConferenceCard.vue?vue&type=script&lang=js"
export * from "./ConferenceCard.vue?vue&type=script&lang=js"
import style0 from "./ConferenceCard.vue?vue&type=style&index=0&id=1f77c83e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports